import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Stack } from '@zurich/ui/atoms';
import { useIsMobile } from '@zurich/ui/hooks';
import { Breadcrumbs, Typography } from '@zurich/ui/legacy/components';
import { useAppLinkUi } from '@zurich/ui/legacy/hooks';
import { styled } from '@zurich/ui/legacy/utils';
// TODO: PartyTile makes no sense maybe SubHeader or ContextHeader [https://azuredevops.at.zurich.com/Zurich/DiTRo/_workitems/edit/64876]
export function PageTitle({ title, subtitle, breadcrumbs, action, children, startAdornment, endAdornment, enableBreadcrumbsOnMobile, }) {
    const AppLinkUi = useAppLinkUi();
    const isMobile = useIsMobile();
    const showBreadcrumbs = breadcrumbs &&
        breadcrumbs?.length > 0 &&
        (isMobile ? enableBreadcrumbsOnMobile : true);
    return (_jsxs(Root, { children: [_jsxs(Stack, { alignItems: "center", direction: "row", justifyContent: "space-between", columnGap: 0, rowGap: 0, children: [_jsxs(BreadcrumbContainer, { children: [showBreadcrumbs && (_jsxs(Breadcrumbs, { truncate: true, children: [startAdornment && (_jsx(AppLinkUi, { style: {
                                            fontSize: '14px',
                                            marginLeft: '2px',
                                            marginBottom: '4px',
                                        }, href: startAdornment.link, children: _jsx(Icon, { variant: startAdornment.icon, size: "small" }) })), breadcrumbs?.map(({ title, link }, index) => link ? (_jsx(AppLinkUi, { href: link, children: title }, index)) : (_jsx(Typography, { variant: "body1", children: title }, index)))] })), _jsxs(ScrollContainer, { children: [_jsx(ScrollGradient, {}), _jsx(TypographyStyled, { variant: "h5", children: title })] }), subtitle && (_jsxs(ScrollContainer, { children: [_jsx(ScrollGradient, {}), _jsx(TypographyStyled, { variant: "subtitle1", children: subtitle })] }))] }), children, action && _jsx("div", { children: action })] }), endAdornment] }));
}
const Root = styled('div')(({ theme }) => ({
    position: 'relative',
    columnGap: theme.spacing(1),
    backgroundColor: theme.palette.primary.contrastText,
    padding: theme.spacing(2, 3),
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(1, 2),
        alignItems: 'center',
    },
}));
const BreadcrumbContainer = styled('div')({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: 'calc(100vw - 30px)',
    flex: '1',
});
const ScrollContainer = styled('div')({
    position: 'relative',
});
const ScrollGradient = styled('div')(({ theme }) => ({
    position: 'relative',
    zIndex: '3',
    '&::after': {
        position: 'absolute',
        top: 0,
        right: 0,
        width: theme.spacing(1.5),
        height: 26,
        background: 'linear-gradient(to right, transparent, white) right /16px 100%',
        backgroundRepeat: 'no-repeat',
        content: '""',
    },
}));
const TypographyStyled = styled(Typography)({
    position: 'relative',
    zIndex: '0',
    overflowY: 'hidden',
    scrollbarWidth: 'none',
});
